// resources/js/src/services/api/client.ts
import axios, { AxiosError } from "axios";
import { ApiError, ApiResponse } from "./types";

const BASE_URL = "/api/v3";

export const client = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

/** Helper داخلي: بيرجّع الـ wrapper كامل { success, message, data, meta, errors } */
async function requestRaw<T>(
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  path: string,
  body?: unknown
): Promise<ApiResponse<T>> {
  const isFormData = body instanceof FormData;
  const headers: Record<string, string> = {};
  if (!isFormData && body !== undefined) {
    headers["Content-Type"] = "application/json";
  }

  try {
    const res = await client.request<ApiResponse<T>>({
      url: path,
      method,
      headers,
      data: body,
    });

    const json = res.data;

    if (!json.success) {
      throw new ApiError(
        res.status,
        json.message || `Request failed with status ${res.status}`,
        json.errors
      );
    }

    return json;
  } catch (error) {
    if (error instanceof ApiError) throw error;

    const axiosError = error as AxiosError<ApiResponse<T>>;
    const status = axiosError.response?.status ?? 0;
    const message =
      axiosError.response?.data?.message ||
      (status ? `Request failed with status ${status}` : "Network error");
    const errors = axiosError.response?.data?.errors;

    throw new ApiError(status, message, errors);
  }
}

/** الافتراضي: يرجع .data بس (زي ما هو دلوقتي) */
export async function request<T>(
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  path: string,
  body?: unknown
): Promise<T> {
  const json = await requestRaw<T>(method, path, body);
  return json.data as T;
}

/** الجديد: يرجع الـ wrapper كامل (للـ feed) */
export async function requestFull<T>(
  method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
  path: string,
  body?: unknown
): Promise<ApiResponse<T>> {
  return requestRaw<T>(method, path, body);
}
